import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import Data_Grid from "../biztran_controls/DataGrid";
import CreateModelMaster from "./CreateModelMaster";
//import AddExpenseSheet from "./AddExpenseSheet";
const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';



const ModelMaster = (props) => {

  const [FromDate, setFromDate] = useState(fromdate);
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [isOpen, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Count, setCount] = useState();
  const [ModelName, setModelName] = useState('');
  const [ModelCode, setModelCode] = useState('');
  const [Statuscmb, setStatuscmb] = useState([]);
  const [ModelID, setModelID] = useState('');
  const [response, fetchData] = UseFetchData();


  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const openModal = (row) => {
    setOpen(true);
    setModelID(row.id);
  };

  const openpath = (row) => {
    debugger;
    //setOpen(true);
    if (row.formattedValue != null && row.formattedValue != "") {
      window.open(row.formattedValue);
    } else {
      alert("No File Attached");
    }

    //console.log(row.UserManual);
  };

  const handleOpenModal = () => {
    setModelID('');
    setOpen(true);
  };

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ModelID", props.ModelID);
    bodyFormData.append("ModelCode", ModelCode);
    bodyFormData.append("ModelName", ModelName);
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    fetchData("Model/List", bodyFormData);
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: "Select",
        //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 120,
      },
      {
        field: "ModelCode",
        headerName: "ModelNo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "ModelName",
        headerName: "Model Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },

      {
        field: "UserManual",
        headerName: "User Manual",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openpath(params); }} >{params.formattedValue === null ? "" : "Download"}</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      // {
      //   field: "WarrantyRegForm",
      //   headerName: "Warranty Registration Form",
      //   renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openpath(params); }} >{params.formattedValue === null ? "" : "Download"}</a> </strong>),
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 280,
      // },
      {
        field: "KitAssemblyInstructions",
        headerName: "Kit Assembly Instructions",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openpath(params); }} >{params.formattedValue === null ? "" : "Download"}</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 270,
      },
      {
        field: "UnpackingManual",
        headerName: "Unpacking Manual",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openpath(params); }} >{params.formattedValue === null ? "" : "Download"}</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 270,
      },

    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]
  );

  useEffect(() => {
    PopulateData();
  }, [])

  return (
    <div>
      <Paper elevation={0}>
        <Grid container direction="row" marginTop={10} style={{ paddingTop: 4 }}>
          <Grid xs={12} md={5} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
            <div style={{ width: "110%", marginLeft: 3, marginTop: 2 }} >
              <div style={{ float: "left", marginTop: 0, width: "80%" }}>
                <BiztranControls.Input
                  label="Model Name"
                  id="ModelName"
                  onChange={(e) => setModelName(e.target.value)}
                />
              </div>
            </div>
          </Grid>

          <Grid style={{ marginTop: 15 }} >
            <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 20 }}>
              <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
            </div>
          </Grid>
          <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginTop: 15 }} >
            <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Button
                  text="SEARCH"
                  startIcon={<SearchIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    PopulateData();
                  }}
                />
              </div>
              <div style={{ float: "left", marginTop: 0, paddingLeft: 5, width: "30%" }}>
                <BiztranControls.Button
                  text="ADD NEW"
                  startIcon={<AddCircleOutlineIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    handleOpenModal();
                  }}
                />
              </div>
            </div>
          </Grid>
        </Grid>

        <Modal_Frame
          title="Add/Edit Model"
          maxWidth="md"
          isOpen={isOpen}
          setOpen={setOpen}
        >
          <CreateModelMaster
            ModelID={ModelID}
            setOpen={setOpen}
            PopulateData={PopulateData}
          />
        </Modal_Frame>

        <BiztranControls.DataGrid
          rowHeight={25}
          headerHeight={34}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          // autoHeight={true}
          Width="97%"
          Height="450px"
          hideFooter={true}
        />
      </Paper>
    </div>
  )
}

export default ModelMaster;